import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChange,
} from "@angular/core";
import { DateService } from '../../../_services/date.service';
import { OfferPlanningService } from "../../../_services/offer-planning.service";
import { PlanningService } from '../../../_services/planning.service';
import { OfferService } from "../../../_services/offer.service";

declare var jQuery: any;

@Component({
  selector: "app-offer-table",
  templateUrl: "./offer-table.component.html",
  styleUrls: ["./offer-table.component.css"],
})
export class OfferTableComponent implements OnChanges {
  @Input() departure_id: number;
  @Input() arrival_id: number;
  @Input() client_id: number;
  @Output() selected: EventEmitter<string> = new EventEmitter<string>();
  @Output() refresh: EventEmitter<boolean> = new EventEmitter<boolean>();

  private changing: boolean = false;
  private shown: boolean = true;

  private offers: any[] = [];

  constructor(
    private service: OfferPlanningService,
    private planning_service: PlanningService,
    private date_service: DateService,
    private offer_service: OfferService
  ) { }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    // console.log('CHANGED')
    this.getOffers();
    this.changing = true;
  }

  getOffers() {
    let departure_city = this.departure_id;
    let arrival_city = this.arrival_id;
    
    if (!departure_city || !arrival_city) {
      console.warn('Les villes de départ et d\'arrivée doivent être définies pour obtenir les offres.');
    return;
  }

    this.service.getOffersWithRating(departure_city, arrival_city).subscribe(response => {
      this.offers = response;
    });

   /* this.service.getOffers(departure_city, arrival_city).subscribe((response) => {
      //ration incidents nb trajets.
      this.offers = response;
    });*/
  }
  getStars(starRating: number): string {
    return '★'.repeat(starRating) + '☆'.repeat(5 - starRating);
  }
  addToPlanning(offer)
  {
    var new_planning = Object.assign({}, offer);
    //console.log(new_planning);
    delete new_planning.id;

    Object.assign(new_planning, { transporter_id: offer.seller }); // Set the receiver_id as seller

    console.log(new_planning);
    // Set Dates values correctly
    if (offer.departure_date != null)
      new_planning.departure_date = this.date_service.myDateFormatted(offer.departure_date);
    else
      new_planning.departure_date = new Date();
    
    if (offer.arrival_date) new_planning.arrival_date = new Date(offer.arrival_date)

    this.planning_service.createPlanning(new_planning).subscribe(response => {
      this.offer_service.updateOffer(offer.id, { planned: true }).subscribe(response => {
        //this.refresh();
        jQuery("#add-planning-modal").modal({ closable: true }).modal("hide");
        this.refresh.emit(true); 
      });
    });
  }
}


// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/offer/offer-table/offer-table.component.ts